export default __webpack_public_path__ + "static/media/Balcony2.5b8b9559.jpg";